import { createTheme } from "@mui/material/styles";

export const EMS_PRIMARY = "#0891B2";
export const EMS_PRIMARY_600 = "#077d9c";
export const EMS_PRIMARY_700 = "#066b85";

const dropdownText = {
  fontFamily: 'Roboto, "Helvetica Neue", Arial, sans-serif',
  fontSize: "0.875rem",
};

export function createEmsTheme(mode = "light") {
  return createTheme({
    palette: {
      mode,
      primary: {
        main: EMS_PRIMARY,
        dark: EMS_PRIMARY_600,
        contrastText: "#ffffff",
      },
      background: {
        default: "var(--ems-bg)",
        paper: "var(--ems-surface)",
      },
    },
    typography: {
      fontFamily: '"Manrope", system-ui, -apple-system, sans-serif',
    },
    components: {
      MuiTableCell: {
        styleOverrides: {
          root: {
            fontFamily: '"Manrope", system-ui, -apple-system, sans-serif',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          containedPrimary: {
            backgroundColor: EMS_PRIMARY,
            color: "#ffffff",
            "&:hover": {
              backgroundColor: EMS_PRIMARY_600,
            },
            "&:disabled": {
              backgroundColor: "rgba(8, 145, 178, 0.45)",
              color: "#ffffff",
            },
          },
        },
      },
      MuiLoadingButton: {
        styleOverrides: {
          root: {
            "&.MuiButton-containedPrimary": {
              backgroundColor: EMS_PRIMARY,
              "&:hover": {
                backgroundColor: EMS_PRIMARY_600,
              },
            },
          },
        },
      },
      MuiTextField: {
        defaultProps: {
          variant: "outlined",
        },
      },
      MuiFormControl: {
        defaultProps: {
          variant: "outlined",
        },
      },
      MuiSelect: {
        styleOverrides: {
          select: dropdownText,
        },
      },
      MuiNativeSelect: {
        styleOverrides: {
          select: dropdownText,
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: dropdownText,
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          input: dropdownText,
          option: dropdownText,
        },
      },
    },
  });
}
